{
  "name": "40-(13-Limit) < 256°",
  "description": "40-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 13. This set combines all of the preceding pitches, and also contains new pitch classes produced by primes interacting with each other (i.e. 5° and 7° combine to produce 35°). This allows chords in which higher primes meet to coexist with the simpler chords featuring only one higher prime.",
  "scale": [
    "65/64",
    "33/32",
    "135/128",
    "35/32",
    "143/128",
    "9/8",
    "147/128",
    "75/64",
    "77/64",
    "39/32",
    "5/4",
    "81/64",
    "165/128",
    "21/16",
    "169/128",
    "175/128",
    "11/8",
    "45/32",
    "91/64",
    "189/128",
    "3/2",
    "195/128",
    "49/32",
    "99/64",
    "25/16",
    "13/8",
    "105/64",
    "27/16",
    "55/32",
    "7/4",
    "225/128",
    "231/128",
    "117/64",
    "15/8",
    "121/64",
    "243/128",
    "245/128",
    "125/64",
    "63/32",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPartials(13L)",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": [
    "1",
    "65",
    "33",
    "135",
    "35",
    "143",
    "9",
    "147",
    "75",
    "77",
    "39",
    "5",
    "81",
    "165",
    "21",
    "169",
    "175",
    "11",
    "45",
    "91",
    "189",
    "3",
    "195",
    "49",
    "99",
    "25",
    "13",
    "105",
    "27",
    "55",
    "7",
    "225",
    "231",
    "117",
    "15",
    "121",
    "243",
    "245",
    "125",
    "63"
  ],
  "note_colors": [
    "#ff8f8f",
    "#e9d7d3",
    "#dfffd6",
    "#fffae5",
    "#ffcba8",
    "#90f9cd",
    "#ffffff",
    "#f8c9c9",
    "#fef5be",
    "#e9ecc1",
    "#e6d7fe",
    "#fffae5",
    "#ffffff",
    "#ddfe95",
    "#ffe5e5",
    "#dbb3ff",
    "#ffd270",
    "#dfffd6",
    "#fffae5",
    "#ebd0e0",
    "#ffe5e5",
    "#ffffff",
    "#e9d7d3",
    "#f8c9c9",
    "#dfffd6",
    "#fef5be",
    "#e6d7fe",
    "#ffcba8",
    "#ffffff",
    "#ddfe95",
    "#ffe5e5",
    "#fef5be",
    "#e9ecc1",
    "#e6d7fe",
    "#fffae5",
    "#c3ffad",
    "#ffffff",
    "#ffb59a",
    "#ffef8a",
    "#ffe5e5"
  ],
  "equivSteps": 40,
  "fundamental": 440,
  "reference_degree": 28,
  "center_degree": 0,
  "rSteps": 6,
  "drSteps": 5,
  "hexSize": 41,
  "rotation": -21.05
}
